import axios from "axios";

export default {
  data() {
    return {
      apiUrl: this.shareFormConfig.api,
      tenantId: this.realm,
      users: [],
      projectMashup: {},
    };
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    //Get Users
    getUsers: function () {
      axios
        .get(this.apiUrl + "/" + this.tenantId + "/users", this.opts)
        .then((response) => {
          this.users = response.data;
          // show the shared users, remove owner from users list, add the owner by default to the shared users list
          this.users.forEach((x) => {
            if (x._id === this.projectMashup.owner) {
              this.sharedUsers.push(x);
              this.users.splice(this.users.indexOf(x), 1);
            }
          });
          this.projectMashup.sharedWith?.forEach((y) => {
            this.users.forEach((x) => {
              if (x._id === y.user) {
                this.sharedUsers.push(x);
                this.users.splice(this.users.indexOf(x), 1);
              }
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getMashup() {
      this.urlPath = window.location.pathname;
      if (this.urlPath.includes("/draw")) {
        this.mashupId = this.urlPath.split("draw/").pop().split("/v")[0];
        this.mashup._id = this.mashupId;
      }
      axios
        .get(
          this.apiUrl +
            "/" +
            this.tenantId +
            "/" +
            this.root +
            "/" +
            this.mashup._id,
          this.opts,
        )
        .then((response) => {
          this.projectMashup = response.data;
          this.getUsers();
        });
    },
  },
};
